import TotalApplications from "../Administration/TotalApplications";

const FireTotalApplications = ({ role }) => {
  return (
    <>
      <TotalApplications role={role} />
    </>
  );
};

export default FireTotalApplications;
